package com.eladfinish.bible.contest.ui.common

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedContentScope
import androidx.compose.animation.core.tween
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.animation.togetherWith
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

const val CONTENT_ANIMATION_DURATION = 200

@Composable
fun <S> AnimatedColumn(
    targetState: S,
    modifier: Modifier = Modifier,
    content: @Composable AnimatedContentScope.(targetState: S) -> Unit,
) {
    AnimatedContent(
        targetState = targetState,
        modifier = modifier,
        transitionSpec = {
            slideInHorizontally(
                animationSpec = tween(CONTENT_ANIMATION_DURATION),
                initialOffsetX = { fullWidth -> fullWidth }
            ) togetherWith
                    slideOutHorizontally(
                        animationSpec = tween(CONTENT_ANIMATION_DURATION),
                        targetOffsetX = { fullWidth -> -fullWidth }
                    )
        },
        content = content,
    )
}
